import { Injectable, inject } from '@angular/core';
import { Notice } from 'src/app/models/notice';
import { ApiAddressService } from '../api.address.service';
import { ApiService } from '../api.service';
import { SharedFunctionService } from '../shared.function.service';

@Injectable({
  providedIn: 'root',
})
export class AdminNoticesService {
  private apiAddressService = inject(ApiAddressService);
  private sharedFunction = inject(SharedFunctionService);
  private apiService = inject(ApiService);


  getAdminSystemNotices(year: number, callback: (data: Notice[]) => void) {
    this.apiService.callApi<Notice[]>('', this.apiAddressService.getAdminSystemNoticesUrl(year), response => {
      callback(response);
    });
  }

  getAdminSystemNotice(noticeId: number, callback: (data: Notice) => void) {
    this.apiService.callApi<Notice>('', this.apiAddressService.getAdminSystemNoticeUrl(noticeId), response => {
      callback(response);
    });
  }

  saveAdminSystemNotice(notice: Notice, callback: (data: Notice) => void) {
    this.apiService.callApi<Notice>(notice, this.apiAddressService.saveAdminSystemNoticeUrl(), response => {
      callback(response);
    });
  }
}
